module.exports = require("jsoneditor/dist/jsoneditor.min.css");